import { getStorageItem } from '@bridge/utils';

export const cookieConsentKey = 'cookie-consent';

export interface CookieConsentOptions {
  strictlyNecessary: true;
  analytical: boolean;
  statistical: boolean;
  marketing: boolean;
  functional: boolean;
}

export type CookieStorageValues = CookieConsentOptions | null | 'null';

export const hasStatisticalConsent = (value: CookieStorageValues): boolean =>
  typeof value === 'object' && value !== null && value.statistical === true;

export const getStoredStatisticalConsent = (): boolean =>
  hasStatisticalConsent(getStorageItem<CookieStorageValues>(cookieConsentKey, null));
